import React, { FC, Fragment } from "react";
import { Button, DialogContent, DialogContentText, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";
import ImageIcon from '@material-ui/icons/Image';

interface Props {
  setImageFile: React.Dispatch<React.SetStateAction<any>>;
  setImageDescription: React.Dispatch<React.SetStateAction<string>>;
  setImgType: React.Dispatch<React.SetStateAction<string>>;
}

const CreatePage: FC<Props> = ({setImageFile, setImageDescription, setImgType}) => {
    const [fileName, setFileName] = React.useState("Ingen fil");
    const [selectedVal, setSelectedVal] = React.useState("");
    
    const handleTextChange = () => (event: React.ChangeEvent<HTMLInputElement>) => {
      setImageDescription(event.target.value);
    };

    const handleChange = (event: React.ChangeEvent<{ value: any, files: any }>) => {
      setFileName(event.target.value)
      if (event.target.files !== null) {
        setImageFile(event.target.files[0]);
      }
  };

  const handleFuncChange = (event: React.ChangeEvent<{ value: any }>) => {
    setImgType(event.target.value);
    setSelectedVal(event.target.value);
  }

  const type = ["Reklame", "Ude Af Drift", "Pauseskærm"];


    return (
        <DialogContent>
          <DialogContentText>
            KRAV TIL BILLEDE
          </DialogContentText>
          <DialogContentText>
            Filformat: jpg eller png
          </DialogContentText>
          <DialogContentText>
            Billedstørrelse max:
            <br/>Ude af drift bredde: 1024px - højde: 768px
            <br/>Pauseskærm bredde: 1024px - højde: 645px
            <br/>Reklame bredde: 1024px - højde: 630px
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Beskrivelse"
            type="text"
            onChange={handleTextChange()}
            fullWidth
            required
          />
          <Fragment>
                <input
                    color="primary"
                    accept="image/png, image/jpeg"
                    type="file"
                    onChange={handleChange}
                    id="icon-button-file"
                    style={{ display: 'none', }}
                />
                    <label htmlFor="icon-button-file">
                        <Button
                            variant="contained"
                            component="span"
                            fullWidth
                            size="large"
                            color="primary"
                        >
                        Vælg billede <ImageIcon />
                        </Button>
                    </label>
            </Fragment>
            <DialogContentText>
                Valgt fil: {fileName}
            </DialogContentText>
            <Fragment>
              <InputLabel id="select-function-label">Billedets funktion</InputLabel>
              <Select
              labelId="select-function-label"
              id="select-function"
              value={selectedVal}
              onChange={handleFuncChange}
              defaultValue=""
              label="location"
              required>
                {type.map((i) => {
                    return (
                        <MenuItem key={i} value={i}> {i} </MenuItem>
                    );
                })}
              </Select>
            </Fragment>
        </DialogContent>
    );
}

export default CreatePage;